import React from 'react'

import { buildImageObj } from '../../lib/helpers'
import { imageUrlFor } from '../../lib/image-url'
import BlockContent from '../shared/blockContent'

import './coreCompetencies.css'

const CoreCompetencies = ({ data }) => {
  return (
    <section className="coreCompetencies">
      {data.title && (
        <div className="heading">
          <h2>{data.title}</h2>
        </div>
      )}
      <div className="content">
        {data.items &&
          data.items.map((item, index) => (
            <div className="competency" key={`competency-${index}`}>
              <img
                src={imageUrlFor(buildImageObj(item.image.image)).width(100).height(100).url()}
                alt={item.image.alt}
                style={{
                  backgroundImage: `url(${imageUrlFor(buildImageObj(item.image.image))
                    .width(100)
                    .height(100)
                    .url()}`,
                }}
              />
              <h3>{item.title}</h3>
              <BlockContent input={item.body} />
            </div>
          ))}
      </div>
    </section>
  )
}

export default CoreCompetencies
